import { createRoot } from 'react-dom/client'
// Import pre-built saas-shell styles (Tailwind + component classes)
import '@roselabs-io/saas-shell/styles'
// Import Falcon-specific overrides (theme colors + animations)
import './index.css'
import App from './App.tsx'
// Initialize Falcon error tracking (dogfooding)
import { initFalconTracker } from './lib/falconTracker'

// Initialize error tracking before rendering
initFalconTracker()

createRoot(document.getElementById('root')!).render(<App />)
